import {
  denormalizeOptionalFields,
  normalizeFormDefaults,
  OptionalKeysArrays,
  WithStringifiedKeys,
} from '../../helpers/formNormalization';
import {
  ApiPhonebookEntry,
  ApiPhonebookEntryCreate,
} from '../../types/PhonebookEntry';

export type PhonebookEntryFormValues = WithStringifiedKeys<
  ApiPhonebookEntryCreate,
  'email' | 'speedDial'
>;

const optionalKeys = {
  string: ['email'],
  number: ['speedDial'],
} as const satisfies OptionalKeysArrays<PhonebookEntryFormValues>;

export const phonebookEntryFormDefaults: PhonebookEntryFormValues = {
  email: '',
  name: '',
  phoneNumber: '',
  priority: 0,
  speedDial: '',
  type: 'phonebookentry',
};

export const normalizePhonebookEntryFormDefaults = (
  entry?: ApiPhonebookEntryCreate | ApiPhonebookEntry,
): PhonebookEntryFormValues => {
  return normalizeFormDefaults(phonebookEntryFormDefaults, entry, [
    ...optionalKeys.string,
    ...optionalKeys.number,
  ]);
};

export const denormalizePhonebookEntryFormValues = (
  values: PhonebookEntryFormValues,
): ApiPhonebookEntryCreate => {
  const normalized = denormalizeOptionalFields(values, optionalKeys);

  return normalized;
};
